module.exports = __webpack_public_path__ + "static/media/login-illustration.2fcbe8e6.png";